import React from "react";
import { ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import { fromJS } from "immutable";
import { getOrderStatus } from "../../redux/selectors";

//The following wrapper is used to avoid an error when using
//more than one icon inside the rightIconButton of a ListItem
const Wrapper = ({
  children,
  style,
  onKeyboardFocus,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onMouseUp,
  onClick,
  ...props
}) => {
  return (
    <div
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseUp={onMouseUp}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

const OrderListItem = ({ order, onClick, rightIcon }) => {
  let avatarImage;
  try {
    avatarImage = require("../../images/" +
      order.orderLines[0].variation.image);
  } catch (ex) {
    avatarImage = require("../../images/noimage.png");
  }

  const teamName = order.team ? `[${order.team.name}] ` : "";
  const name = teamName + order.customerName;
  const price = order.orderLines
    .map(line => line.unitPrice * line.quantity)
    .reduce((a, b) => a + b, 0);

  const orderStatus = getOrderStatus;

  const currentStatus = orderStatus(order);
  const backgroundColor = order.delivered
    ? "mediumpurple"
    : order.paid
      ? currentStatus === "DOING"
        ? "orange"
        : currentStatus === "DONE" ? "lightgreen" : "lightgrey"
      : "red";

  const listItemStyle = {
    float: "right",
    height: "40px",
    width: "5px",
    margin: "0 5px",
    backgroundColor: backgroundColor
  };

  const innerStyle = { paddingRight: "96px" };

  const orderLines = order.orderLines.map((ol, index) =>
    <span key={index} style={{ marginRight: 6 }}>
      {`${ol.quantity}x[${ol.variation.product.name}]${ol.variation.name}`}
    </span>
  );

  const rightIconMenu = (
    <Wrapper>
      <span style={{ verticalAlign: "super" }}>
        {price} €
      </span>
      {rightIcon}
    </Wrapper>
  );
  return (
    <ListItem
      hoverColor="rgba(0,0,0,0.1)"
      innerDivStyle={innerStyle}
      onClick={e => onClick(fromJS(order))}
      leftAvatar={
        <div>
          <Avatar src={avatarImage} />
          <div style={listItemStyle} />
        </div>
      }
      rightIconButton={rightIconMenu}
      primaryText={
        <span>
          {name}
        </span>
      }
      secondaryText={
        <p>
          {orderLines}
        </p>
      }
      secondaryTextLines={1}
    />
  );
};

export default OrderListItem;



// WEBPACK FOOTER //
// ./src/components/presentational/OrderListItem.js